import { Box, Card, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FormType } from '@/api/enum/formType.enum';
import { useState } from 'react';
import EmoInfoForm from './components/EmoInfoForm';

export default function CreateEmoPage() {
	const { t } = useTranslation();
	const [type, setType] = useState<FormType>(FormType.create);
	return (
		<>
			<Box sx={{ width: '100%' }}>
				<Box>
					<Typography variant='h4'>{t('drawerListItems.addItem')}</Typography>
					<Card sx={{ marginTop: 3 }}>
						<EmoInfoForm type={type} setType={setType} />
					</Card>
				</Box>
			</Box>
		</>
	);
}
